export const reviews = [
  {
    name: "IC",
    review:
      '"I have been attending Kenworthy Chiropractic for a number of years now and for all but one appointment I have always seen Johanna the owner. She has provided me with a string of 10 week “MOTs” to realigned my posture from the slippage that it suffers due to my arthritis. Her technique is non-intrusive which suits me. I shall continue to attend for a “re-setting” process so long as I am able."',
    rating: 5,
  },
  {
    name: "N",
    review:
      '"Johanna is amazing. It is a very welcoming environment and easy to talk to to explain what’s causing issues and what needs to be done."',
    rating: 5,
  },
  {
    name: "H",
    review:
      '"Johanna and her team have been excellent in the treatment of severe back pain. When I first came to her I could barely put my own shoes on. Now I have very little discomfort. They have all been very supportive in what has been a difficult time. Highly recommend."',
    rating: 5,
  },
  {
    name: "DD",
    review:
      '"We took our four month old to see Johanna and she has made such a difference. My baby can easily move her head from side to side now and is sleeping better and overall seems happier. Johanna was absolutely amazing with our baby and was really informative during the sessions to tell me what she was doing and what the cause for my babies discomfort had been. I wish I had brought her sooner! I would highly recommend Johanna and I\'m so thankful to her for helping us!"',
    rating: 5,
  },
  {
    name: "WP",
    review:
      '"Immediate improvement for my sore hand from Becky on my first visit for this current problem. Generally impressed by the professionalism and efficiency at Kenworthy Chiropractic too."',
    rating: 5,
  },
  {
    name: "BC",
    review: `"If your thinking of visiting a Chiropractor, then don't hesitate to call Kenworthy Chiropractic."`,
    rating: 5,
  },
  {
    name: "AB",
    review:
      '"I have no hesitation in highly recommending this clinic for your aches and pains! The staff members are friendly, helpful and caring. After 3 gentle treatments, Johanna has straightened me out and restored my balance, even restoring some of my hearing after years of difficulty! A true healer - thank you Johanna!"',
    rating: 5,
  },
  {
    name: "SH",
    review:
      '"Well my 1st visit was amazing Johanna definitely knows her job. Worth her weight in gold..."',
    rating: 5,
  },
  {
    name: "JD",
    review:
      '"I have always had the best care from Kenworthy. All the staff are friendly,efficient and very welcoming. From my original diagnosis and eventually being pain free to restarting treatment again after another injury I can say that I have been treated professionally and courteously. I would highly recommend this gentle but thorough approach of chiropractic healing."',
    rating: 5,
  },
];
